/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    FlagOutlined,
    MailOutline,
    PhoneAndroidOutlined,
    WarningAmberOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPQRS} from "../../Constantes";

const Formulario_Pqrs = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOSPQRS.map((it) => it.nombre)}
                    />
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={WarningAmberOutlined} nombre={'Tipo'} dato={'opcion'} {...props}
                                   opciones={['Peticiones', 'Quejas', 'Reclamos', 'Sugerencias']} editable={false}
                    />
                </Grid2>


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}

                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo'} dato={'correo'} {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Celular'} dato={'celula'} {...props}
                    />
                </Grid2>


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Mensaje'} dato={'notas'} {...props}
                                  lineas={6}

                    />
                </Grid2>


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Notas Internas'} dato={'notas_internas'} {...props}
                                  lineas={6}

                    />
                </Grid2>


            </Grid2>

        </form>

    )

}
export default Formulario_Pqrs